/** @jsx React.DOM */
var React = require("react/addons");

var WatchStoreMixin = require("editor/mixins/WatchStore");
var ContextMenuStore = require("editor/stores/ContextMenuStore");

var ContextMenu = React.createClass({displayName: 'ContextMenu',
  mixins: [ WatchStoreMixin(ContextMenuStore) ],

  getFluxState: function() {
    return ContextMenuStore.getState();
  },

  render: function() {
    if (!this.state.isVisible) return null;

    var menuStyle = {
      position: "fixed",
      zIndex: 100,
      top: this.state.coords.y,
      left: this.state.coords.x
    };

    return (
      React.DOM.div({style: menuStyle, className: "open"}, 
        React.DOM.ul({className: "dropdown-menu", role: "menu"}, 
          this.state.options.reduce(function(acc, group, index, array) {
            var boundedGroup = group.map(function(item) {
              return React.DOM.li(null, React.DOM.a({href: "#", 'data-name': item.title, onClick: item.onClick}, item.title));
            })

            if (array.length !== index + 1) {
              boundedGroup.push(React.DOM.li({className: "divider"}));
            }

            return acc.concat(boundedGroup);
          }, [])
        )
      )
    );
  }
});

module.exports = ContextMenu;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/common/ContextMenu.js
 ** module id = 31
 ** module chunks = 0
 **/